import { render, staticRenderFns } from "./EventSettingsTab.vue?vue&type=template&id=0a32ebd3&scoped=true&"
import script from "./EventSettingsTab.vue?vue&type=script&lang=js&"
export * from "./EventSettingsTab.vue?vue&type=script&lang=js&"
import style0 from "./EventSettingsTab.vue?vue&type=style&index=0&id=0a32ebd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32ebd3",
  null
  
)

export default component.exports